import { ApiProxy } from '@/utils'
import Api from './api'

export const api = ApiProxy(Api)

